import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { LeadService } from '../services/lead.service';
import { ActivatedRoute, Router } from '@angular/router';

import { Quote } from '../../shared/models/quote.interface';
import { NgForm, ValidationErrors } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { Customer } from '../../shared/models/customer.interface';
import { QuoteBase } from '../../shared/models/quote.base.interface';
import {RolePermission } from '../../shared/models/role.permission.enum';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent extends AbstractBiditComponent {
  lead: Quote = {
    customer: {} as Customer
  } as Quote;

  canEdit: boolean = true;
  canAddQuote: boolean = true;
  readOnly: boolean = true;

  constructor(@Inject(LOCALE_ID) private locale: string,
    private leadService: LeadService, deviceDetectorService: DeviceDetectorService,
    private router: Router, private route: ActivatedRoute) {
    super(deviceDetectorService);
  }

  init() {
    this.canEdit = LeadService.hasPermission(RolePermission.EditLead);
    this.canAddQuote = LeadService.hasPermission(RolePermission.AddQuote);

    this.route.paramMap.subscribe(params => {
      let quoteId = params.get('quoteId');

      if (quoteId) {
        this.refreshLead(parseInt(quoteId));
      }
    });
    this.route.queryParamMap.subscribe(params => {
      let mode = params.get('mode');

      if (mode == 'edit') {
        this.readOnly = false;
      }
    });
  }

  get noteLabel(): string {
    if (this.locale == 'es')
      return `Notas (${this.lead.notes?.length})`;

    return `Notes (${this.lead.notes?.length})`;
  }

  get documentLabel(): string {
    if (this.locale == 'es')
      return `Documentos (${this.lead.documents?.length})`;

    return `Documents (${this.lead.documents?.length})`;
  }

  leadUpdated(quote: QuoteBase) {
    this.refreshLead(quote.quote_ID);
  }

  refreshLead(quoteId: number) {
    this.leadService.getProject(quoteId)
      .subscribe({
        next: (data) => {
          this.lead = data.quote;
        }
      });
  }

  expireLead() {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    this.leadService.expireLead(this.lead.quote_ID)
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe(
        {
          next: (result) => {
            if (result) {
              this.router.navigate(['/lead']);
            }
          },
          error: (error: string) => this.errors = error
        });
  }

  deleteLead() {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    this.leadService.deleteLead(this.lead.quote_ID)
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe(
        {
          next: (result) => {
            if (result) {
              this.router.navigate(['/lead']);
            }
          },
          error: (error: string) => this.errors = error
        });
  }
}
